import { Entitlements } from 'shared/types/entitlements';
import { User } from 'shared/types/user';

export const getUserHasPremium = (user: User | null | undefined) =>
  !!user?.entitlements?.includes(Entitlements.Premium);
